import { render, staticRenderFns } from "./ExamineeResult.vue?vue&type=template&id=254b53a2&scoped=true&"
import script from "./ExamineeResult.vue?vue&type=script&lang=js&"
export * from "./ExamineeResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeResult.vue?vue&type=style&index=0&id=254b53a2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b53a2",
  null
  
)

export default component.exports